module.exports = __webpack_public_path__ + "dec0ada1a5fec02a336f01d8ae7b733b.svg";